var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagShopping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 160H344V120C344 53.828 290.172 0 224 0S104 53.828 104 120V160H32C14.326 160 0 174.326 0 192V432C0 476.182 35.818 512 80 512H368C412.184 512 448 476.182 448 432V192C448 174.326 433.674 160 416 160ZM152 120C152 80.297 184.297 48 224 48S296 80.297 296 120V160H152V120ZM400 432C400 449.645 385.645 464 368 464H80C62.355 464 48 449.645 48 432V208H104V264C104 277.25 114.75 288 128 288S152 277.25 152 264V208H296V264C296 277.25 306.75 288 320 288S344 277.25 344 264V208H400V432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagShopping);
export default __webpack_public_path__ + "static/media/bag-shopping.a5a923c69fc92fc4df80bafc15f9c286.svg";
export { ForwardRef as ReactComponent };